module.exports = __webpack_public_path__ + "img/HK.974ba8b4.png";